/* eslint-disable react/prop-types */
import React from 'react';
import cn from 'clsx';
import { ReactComponent as FolderViewSelected } from 'assets/icons/New/folder-view-selected.svg';
import { ReactComponent as FolderView } from 'assets/icons/New/folder-view.svg';
import { ReactComponent as FileViewSelected } from 'assets/icons/New/file-view-selected.svg';
import { ReactComponent as FileView } from 'assets/icons/New/file-view.svg';
import { VIEW_MODE } from './constants';
import classes from './ViewMode.module.scss';

const ViewMode = ({ currentMode, onChange, className }) => {
  return (
    <span className={cn(classes.wrapper, className)}>
      {currentMode === VIEW_MODE.FOLDER ? (
        <FolderViewSelected />
      ) : (
        <FolderView
          onClick={() => {
            onChange(VIEW_MODE.FOLDER);
          }}
        />
      )}
      <span />
      {currentMode === VIEW_MODE.FILE ? (
        <FileViewSelected />
      ) : (
        <FileView
          onClick={() => {
            onChange(VIEW_MODE.FILE);
          }}
        />
      )}
    </span>
  );
};

export default ViewMode;
